import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { FormattedRelativeTime } from '../../../../components/FormattedRelativeTime'
import { ConfigDiff } from './ConfigDiff'

const actorName = (t, createdBy) =>
  createdBy ? `${createdBy.first_name || ''} ${createdBy.last_name || ''}`.trim() || createdBy.email : t('receiving_config.history.system')

// Memoised: row identities are stable across renders (react-query's structuralSharing keeps
// them), so paging in another page re-diffs only the new rows instead of every loaded one.
export const HistoryEntry = memo(({ row }) => {
  const { t } = useTranslation()
  return (
    <li className="border border-gray-200 rounded-md p-4 bg-white">
      <div className="flex items-center gap-2 text-sm">
        <span className="font-medium text-gray-900">{actorName(t, row.created_by)}</span>
        <span className="text-gray-400" title={row.created_at}>
          <FormattedRelativeTime date={row.created_at} />
        </span>
        {row.forced && (
          <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
            {t('receiving_config.history.forced')}
          </span>
        )}
        <span className="text-gray-400">#{row.id}</span>
      </div>
      <p className="mt-1 text-sm text-gray-700">{row.reason}</p>
      <div className="mt-3">
        <ConfigDiff before={row.before_config} after={row.after_config} />
      </div>
    </li>
  )
})
HistoryEntry.displayName = 'HistoryEntry'
